/**
 * Build a same-origin deep-link to a raw alarm's investigation view.
 * Returns `null` when either `alarmId` or `partitionKey` is missing.
 *
 * This is the canonical builder for URLs of the shape
 * `${origin}/alarms/${id}?partitionKey=${key}`. Use this for alarms that
 * aren't tied to a location (e.g. enterprise alarms) — see
 * `locationAlarmUrl` for location-scoped alarms.
 */
export function rawAlarmUrl(
  alarmId?: string,
  partitionKey?: string
): string | null {
  if (!alarmId || !partitionKey) return null;
  return `${window.location.origin}/alarms/${alarmId}?partitionKey=${partitionKey}`;
}
